export const DEVICE_SETTINGS_STORAGE_KEY = 'video-device-preferences.v1';

const VERSION = 1;

const getStorage = () => {
  try {
    return typeof window === 'undefined' ? undefined : window.localStorage;
  } catch (error) {
    return undefined;
  }
};

const removePreferences = storage => {
  try {
    storage.removeItem(DEVICE_SETTINGS_STORAGE_KEY);
  } catch (error) {
    // Device preferences are best-effort.
  }
};

export const readDevicePreferences = () => {
  const storage = getStorage();
  if (!storage) return {};

  try {
    const value = storage.getItem(DEVICE_SETTINGS_STORAGE_KEY);
    if (!value) return {};
    const parsed = JSON.parse(value);
    if (!parsed || typeof parsed !== 'object' || parsed.version !== VERSION) {
      removePreferences(storage);
      return {};
    }
    return {
      microphoneDeviceId:
        typeof parsed.microphoneDeviceId === 'string'
          ? parsed.microphoneDeviceId
          : undefined,
      cameraDeviceId:
        typeof parsed.cameraDeviceId === 'string'
          ? parsed.cameraDeviceId
          : undefined,
      speakerDeviceId:
        typeof parsed.speakerDeviceId === 'string'
          ? parsed.speakerDeviceId
          : undefined,
    };
  } catch (error) {
    removePreferences(storage);
    return {};
  }
};

export const updateDevicePreferences = patch => {
  const storage = getStorage();
  if (!storage) return;
  const preferences = { ...readDevicePreferences(), ...patch };
  Object.keys(preferences).forEach(key => {
    if (preferences[key] === undefined) delete preferences[key];
  });
  try {
    storage.setItem(
      DEVICE_SETTINGS_STORAGE_KEY,
      JSON.stringify({ version: VERSION, ...preferences }),
    );
  } catch (error) {
    // Preference persistence must never block media setup.
  }
};

export const clearDevicePreference = field =>
  updateDevicePreferences({ [field]: undefined });
